import { CONNECT_LINKS, DEFAULT_LINK } from 'src/constants';

export const recognizeLink = (link: string): AnyObject => {
  return CONNECT_LINKS.find((item) => link.toLowerCase().includes(item.contains)) || DEFAULT_LINK;
};
